import React from 'react';

const ConnectedAccountsSkeleton = () => {
  return (
    <div
      className='rounded-lg p-6 flex flex-col h-full'
      style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
    >
      <div className='flex items-center justify-between mb-4'>
        <div className='skeleton h-4 rounded w-32' />
        <div className='skeleton w-5 h-5 rounded' />
      </div>
      <div className='space-y-3'>
        {[...Array(3)].map((_, idx) => (
          <div
            key={idx}
            className='rounded-lg p-3 flex items-center justify-between'
            style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)' }}
          >
            <div className='flex items-center gap-3'>
              <div className='skeleton w-8 h-8 rounded-full' />
              <div>
                <div className='skeleton h-4 rounded w-32 mb-1' />
                <div className='skeleton h-3 rounded w-24' />
              </div>
            </div>
            <div className='skeleton w-2 h-2 rounded-full' />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectedAccountsSkeleton;
